import { Navigate, useLocation } from "react-router-dom";
import { useMemberAuth } from "./MemberAuthContext";

export default function MemberProtectedRoute({ children }) {
  const { member, loading } = useMemberAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--secondary))]">
        <div className="text-center" data-testid="member-auth-loading">
          <div className="overline">A verificar acesso</div>
        </div>
      </div>
    );
  }

  if (!member) {
    return <Navigate to="/membros/login" replace state={{ from: location }} />;
  }

  return children;
}
